<template>
  <div :loading="loading" class="app-container">
    <div class="fixedButton" v-show="isShowReturn">
      <vxe-button class="examineButton" @click="ReturnFun">返回</vxe-button>
<!--      <vxe-button v-if="!showSaveBtn && showPublish1" status="primary" @click="editFun">编辑</vxe-button>-->
<!--      <vxe-button v-if="showSaveBtn" class="examineButton" @click="cancelFun">取消</vxe-button>-->
<!--      <vxe-button v-if="showSaveBtn" status="success" @click="saveFun">保存</vxe-button>-->
<!--      <vxe-button v-if="showPublish" v-waves class="examineButton" status="success" @click="submint">发布</vxe-button>-->
    </div>
    <div class="CertificateReleaseApplicationBox scrollBars" :style="`height:${$store.state.app.height - 80}px;`">

      <div>
        <a-form
            ref="baseForm"
            :model="formData"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 16 }"
            style="padding-right: 0px;"
        >
          <a-row :gutter="24">
<!--            <div class="item-line" style="margin: 0px">基础信息</div>-->
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="拜访类型">
                <a-input :value="(formData.visitType === '2' || formData.visitType === 2) ? '服务' : ((formData.visitType === '1' || formData.visitType === 1) ? '销售' : (formData.visitTypeName || ''))" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="省份">
                <a-input v-model="formData.provinceName" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="城市">
                <a-input v-model="formData.cityName" :disabled="true" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="客户来源">
                <a-input v-model="formData.visitSourceName" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="客户名称">
                <a-input v-model="formData.customerName" :disabled="true" />
              </a-form-item>
            </a-col>
          <a-col :span="8">
            <a-form-item label="品系">
              <a-input v-model="formData.strainName" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="姓名">
              <a-input v-model="formData.name" :disabled="true" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="职位">
              <a-input v-model="formData.post" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="联系方式">
              <a-input v-model="formData.contactPhone" :disabled="true" />
            </a-form-item>
          </a-col>
<!--          <a-col :span="8">-->
<!--            <a-input v-model="formData.segmentedIndustryText" :disabled="true" />-->
<!--          </a-col>-->
            <a-col :span="8">
              <a-form-item label="细分行业">
                <a-input v-model="formData.segmentedIndustryText" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :span="8"></a-col>
            <a-col :span="8"></a-col>
        </a-row>
<!--        <a-row :gutter="24">-->
<!--          <a-col :span="8">-->
<!--            <a-form-item label="细分行业">-->
<!--              <a-input v-model="formData.segmentedIndustryText" :disabled="true" />-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :span="8"></a-col>-->
<!--          <a-col :span="8"></a-col>-->
<!--        </a-row>-->
        <a-row :gutter="24">
<!--          <div class="item-line" style="margin: 0px">位置及在用车辆信息</div>-->
        </a-row>
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="客户位置定位">
              <a-input v-model="formData.locationAddress" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="在用车辆信息">
              <a-input v-model="formData.currentVehicleInfo" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="客户车辆保有量">
              <a-input v-model="formData.custVehCount" :disabled="true" />
            </a-form-item>
          </a-col>
        </a-row>

          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="客户等级">
                <a-input v-model="formData.customerLevelName" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="客户是否有意向">
                <a-input :value="formData.intentional === 1? '是' : formData.intentional === 1 ? '否': '未知'" :disabled="true" ></a-input>
              </a-form-item>
            </a-col>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item label="客户需求总数量">
                  <a-input v-model="formData.demandCount" :disabled="true" />
                </a-form-item>
              </a-col>
          </a-row>

        <a-row :gutter="24">
<!--          <div class="item-line" style="margin: 0px">客户购车意向</div>-->
        </a-row>
          <a-col :span="8">
            <a-form-item label="车型配置">
              <a-input v-model="formData.intentionCarConfig" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="需求品系">
              <a-input v-model="formData.intentionSeriesStrainsName" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="预计购车日期">
              <a-input v-model="formData.estimatedPurchaseDate" :disabled="true" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">

<!--          <a-col :span="8"></a-col>-->
<!--          <a-col :span="8"></a-col>-->
          <a-col :span="8">
            <a-form-item label="服务商品需求">
              <a-input v-model="formData.serviceProductDemandsText" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="后市场配件需求">
              <a-input v-model="formData.aftermarketPartsDemandsText" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="拜访人上级部门">
              <a-input v-model="formData.regionName" :disabled="true" />
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 服务拜访扩展信息 -->
        <template v-if="formData.visitType === '2' || formData.visitType === 2">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="车辆保有情况">
                <a-input v-model="formData.vehicleQuantityInfo" :disabled="true" placeholder="乘龙及其他品牌车辆保有量" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="自建修理厂/工">
                <a-input :value="formData.hasOwnRepairShop === 1 ? '是' : (formData.hasOwnRepairShop === 0 ? '否' : '')" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="最近保障站名称">
                <a-input v-model="formData.nearestGuaranteeStation" :disabled="true" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="保障站距离(km)">
                <a-input :value="formData.stationDistance != null && formData.stationDistance !== '' ? formData.stationDistance + ' km' : ''" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="货物类型及载重">
                <a-input v-model="formData.cargoTypeAndLoad" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="注册乘龙V+系统">
                <a-input :value="formData.isRegisteredVplus === 1 ? '是' : (formData.isRegisteredVplus === 0 ? '否' : '')" :disabled="true" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" v-if="formData.isRegisteredVplus === 0">
            <a-col :span="24">
              <a-form-item label="未注册V+原因" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-input v-model="formData.unregisteredVplusReason" :disabled="true" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item label="运营路线" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-textarea v-model="formData.operationRoute" :disabled="true" :autosize="{ minRows: 2, maxRows: 4 }" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="能耗对比情况" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-textarea v-model="formData.energyConsumptionComparison" :disabled="true" :autosize="{ minRows: 2, maxRows: 4 }" />
              </a-form-item>
            </a-col>
          </a-row>
        </template>

        <a-row :gutter="24">
        </a-row>
          <a-row :gutter="24">
            <div class="budgetBox bodyBox">
              <a-form-model style="padding-right: 0px">
                <div style="margin-left: 2%">
                  <a-form-model-item label="拜访记录" style="margin-bottom: 5px">
                    <el-input
                        v-model="formData.visitContentRecord"
                        type="textarea"
                        style="width: 100%"
                        show-word-limit
                        :autosize="{ minRows: 2, maxRows: 10 }"
                    />
                  </a-form-model-item>
                  <a-form-model-item label="服务/质量问题反馈" style="margin-bottom: 5px">
                    <el-input
                        v-model="formData.serviceFeedBack"
                        type="textarea"
                        style="width: 100%"
                        show-word-limit
                        :autosize="{ minRows: 2, maxRows: 10 }"
                    />
                  </a-form-model-item>

                  <a-form-model-item label="需总部支持项" style="margin-bottom: 5px">
                    <el-input
                        v-model="formData.support"
                        type="textarea"
                        style="width: 100%"
                        show-word-limit
                        :autosize="{ minRows: 2, maxRows: 10 }"
                    />
                  </a-form-model-item>
                  <a-form-model-item label="现场图片（含给客户解读运营报告图）">
<!--                    <el-input-->
<!--                        v-model="visitObj.writeOffOther"-->
<!--                        type="textarea"-->
<!--                        style="width: 80%"-->
<!--                        :disabled="editDisabled"-->
<!--                        maxlength="400"-->
<!--                        show-word-limit-->
<!--                        :autosize="{ minRows: 4, maxRows: 6 }"-->
<!--                    :src="`https://your-domain.com/${src}`"-->
<!--                    />-->
                    <template>
                      <div>
                        <a
                            v-for="(src, index) in formData.photoList"
                            :key="index"
                            :href="baseImageUrl + src" target="_blank">
                          <img
                              :src="baseImageUrl + src"
                              style="width: 100px; height: auto; margin-right: 8px;"
                              alt="照片"
                          />
                        </a>
                      </div>
                    </template>
                  </a-form-model-item>
                </div>
              </a-form-model>
            </div>
          </a-row>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import waves from '@/directive/waves'
import { dataApi } from '@/services/bigCustomer/visitRecord.js'
import moment from 'moment';
import {formMixin,fmt} from "@/utils/common/FormBase";

const defaultActivity = {
  id: '',
  actName: '', // 活动名称
  budgetTypeCode: '', // 预算类型编码
  budgetTypeName: '',
  oneLevelCode: '', // 一级来源编码
  oneLevelName: '',
  twoLevelCode: '', // 二级来源编码
  twoLevelName: '',
  threeLevelCode: '', // 三级来源编码
  threeLevelName: '',
  fourLevelCode: '', // 四级来源编码
  fourLevelName: '',
  fiveLevelCode: '', // 五级来源编码
  fiveLevelName: '',
  planStatus: 0, // 活动计划状态:0待发布，1已发布，2已失效
  planStartTime: '', // 计划生效时间
  planEndTime: '', // "计划失效时间/计划结束时间
  type: 1, // 计划类型 0大区-区域基金 1总部
  planCode: '', // 活动编码
  remarks: '', // 备注
  writeOffAnnex: '',
  writeOffInvoices: ''
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  console.log('加载数据>>>:' + rowId);
  if (rowId) {
    this.isShowReturn = false;
    dataApi.getDetail(rowId).then(res => {
      if (res.code === 200 && res.data) {
        this.formData = res.data
        if (this.formData.segmentedIndustries && Array.isArray(this.formData.segmentedIndustries) && this.formData.segmentedIndustries.length > 0){
          this.formData.segmentedIndustryText = this.formData.segmentedIndustries.map(item => item.value).join('，')
        }
        if (this.formData.serviceProductDemands && Array.isArray(this.formData.serviceProductDemands) && this.formData.serviceProductDemands.length > 0){
          this.formData.serviceProductDemandsText = this.formData.serviceProductDemands.map(item => item.value).join('，')
        }
        if (this.formData.aftermarketPartsDemands && Array.isArray(this.formData.aftermarketPartsDemands) && this.formData.aftermarketPartsDemands.length > 0){
          this.formData.aftermarketPartsDemandsText = this.formData.aftermarketPartsDemands.map(item => item.value).join('，')
        }
        try {
          // this.formData.photoList = JSON.parse(this.formData.photos || '[]');
          this.formData.photoList = this.formData.photos.split(',').map(s => s.trim());
          console.log('分割后的图片：', this.formData.photoList);
        } catch (e) {
          console.log('分割图片异常：', this.formData.photoList);
          this.formData.photoList = [];
        }
        // this.loading = false
        return this.formData;
      } else {
        this.$message.error(res.msg)
        return null;
      }
    })
  }
  return fmt.formatFormLoad(this.formData);
}

export default {
  mixins: [formMixin],
  name: 'DetailsActivity',
  // inject: ['reload'],
  directives: { waves },
  components: {
    // FiveSourceTree
  },
  data() {
    return {
      isShowReturn: true,
      formData:{},
      baseImageUrl: api.temp.FILE_PATH,
      // selectedOrgText: null,
      rules: {
        planStartTime: [{ required: true, message: '请选择生效时间', trigger: 'blur' }],
        planEndTime: [{ required: true, message: '请选择失效时间', trigger: 'blur' }],
        projectCode: [{ required: true, message: '请输入政策立项编号', trigger: 'blur' }],
        selectedOrgText: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!this.selectedOrgText) {
                callback(new Error('请选择活动来源'))
                return
              }
              callback()
            },
            trigger: 'blur'
          }
        ]
      },
      dealerRules: {
        feeLimit: [{ required: true, message: '请输入费用额度', trigger: 'blur' }],
        writeRate: [{ required: true, message: '请输入核销比例', trigger: 'blur' }],
        executeFreq: [{ required: true, message: '请输入执行频次', trigger: 'blur' }]
      },
      conditions: {
        dealerName: null,
        sectorId: null,
        provinceId: null,
        cityId: null
      },
      strDate: {
        planstarttimesham: null,
        planendtimesham: null
      },
      visitObj: Object.assign({}, defaultActivity),
      modelTableBase: {
        data: [],
        loading: false,
        selection: []
      },
      pagination: {
        total: 0,
        size: 10,
        current: 1
      },
      sectorList: [],
      provinceList: [],
      cityList: [],
      uploadDialog: false,
      importLoading: false,
      fileList: [],
      errorList: [],
      showPublish: false,
      showPublish1: false,
      loading: false,
      editDialog: false,
      editData: {},
      emptyText: '无',
      carStrainList: [],
      showCarSeries: false,
      showSaveBtn: false,
      editDisabled: true,
      showTreeDialog: false,
      treeProps: {
        label: 'sourceName',
        children: 'children'
      },
      sourceData: [
        {
          sourceCode: 'default',
          parentNodeId: 'A',
          sourceName: '活动来源',
          enableSelect: '0',
          children: []
        }
      ],
      treeData: [],
      selectData: {},
      classType: {},
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
    }
  },
  computed: {
    selectedOrgText() {
      return this.visitObj.oneLevelName + '/' +
          this.visitObj.twoLevelName + '/' +
          this.visitObj.threeLevelName //+ '/' +
      //  this.visitObj.fourLevelName + '/' +
      //  this.visitObj.fiveLevelName
    },
    checkKey() {
      return this.visitObj.fiveLevelCode
    }
  },
  watch: {
  },
  created() {
    this.visitObj.id = this.$route.params.id
    console.log(this.$route.params,'--this.$route.params--');

    if (this.$route.params.id) {
      this.getVisitDetail(this.$route.params.id)
    }
    if (this.$route.params.state === 'publish') {
      this.showPublish = true
    }
  },
  methods: {
    loadEntity,
    clearData1() {
      this.conditions.dealerName = null
      this.conditions.provinceId = null
      this.conditions.cityId = null
      this.conditions.sectorId = null
    },
    getVisitDetail(id) {
     // this.loading = true
     dataApi.getDetail(id).then(res => {
        if (res.code === 200 && res.data) {
          this.formData = res.data
          if (this.formData.segmentedIndustries && Array.isArray(this.formData.segmentedIndustries) && this.formData.segmentedIndustries.length > 0){
            this.formData.segmentedIndustryText = this.formData.segmentedIndustries.map(item => item.value).join('，')
          }
          if (this.formData.serviceProductDemands && Array.isArray(this.formData.serviceProductDemands) && this.formData.serviceProductDemands.length > 0){
            this.formData.serviceProductDemandsText = this.formData.serviceProductDemands.map(item => item.value).join('，')
          }
          if (this.formData.aftermarketPartsDemands && Array.isArray(this.formData.aftermarketPartsDemands) && this.formData.aftermarketPartsDemands.length > 0){
            this.formData.aftermarketPartsDemandsText = this.formData.aftermarketPartsDemands.map(item => item.value).join('，')
          }
          try {
            // this.formData.photoList = JSON.parse(this.formData.photos || '[]');
            this.formData.photoList = this.formData.photos.split(',').map(s => s.trim());
            console.log('分割后的图片：', this.formData.photoList);
          } catch (e) {
            console.log('分割图片异常：', this.formData.photoList);
            this.formData.photoList = [];
          }
          // this.loading = false
          return this.formData;
        } else {
          this.$message.error(res.msg)
          return null;
        }
      })
      return null;
    },
    uploadFun() {
      this.uploadDialog = true
    },

    onShowCarSeries() {
      // 使用逗号分割字符串
      const stringArray = this.visitObj.strainsCarName.split(',')
      // 创建一个数组来存放对象
      const objectArray = []
      // 遍历分割后的字符串数组，并将每个元素转换为对象
      stringArray.forEach(function(item) {
        var parts = item.split('-') // 使用短横线分割每个元素
        if (parts.length === 2) {
          var obj = {
            strains: parts[0],
            carSeries: parts[1]
          }
          objectArray.push(obj)
        }
      })
      this.carStrainList = objectArray
      this.showCarSeries = true
    },
    showTree() {
      this.showTreeDialog = false
      this.$refs.selectOrgPopup.blur()
    },
    handleDialogCancel() {
      this.$refs.sourceTree.$refs.tree.setCheckedKeys([this.visitObj.fiveLevelCode])
      this.showTreeDialog = false
    },
    handleDialogConfirm() {
      this.selectData = this.$refs.sourceTree.selectData
      Object.assign(this.visitObj, this.selectData)
      this.showTreeDialog = false
    },

    // 上传前对文件的大小的判断
    uploadBefore(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message('只能上传后缀是.xlsx或者.xls的文件')
        return false
      }

      if (size > 10) {
        this.$message('文件大小不得超过10M')
        return false
      }
    },

    // 获取五级来源
    getFiveLevelSource() {
      // getOrganizationList().then(res => {
      //   if (res.code === 1) {
      //     this.sourceData[0].children = res.data
      //     this.treeData = this.formatData(this.sourceData)
      //   }
      // })
    },
    // 树形数据初始化，外层节点添加disabled
    formatData(params) {
      const data = params
      data.forEach((item) => {
        if (item.children.length !== 0) {
          item.disabled = true
          this.formatData(item.children)
        }
      })
      return data
    },
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      pageSize !== this.pagination.size && (this.pagination.current = 1)
      this.pagination.size = pageSize
    },
    // 返回
    ReturnFun() {
      this.$closePage('/bigCustomer/visitDetail', '/bigCustomer/visit')
    },

    changeProvince() {
      if (this.conditions.provinceId) {
        this.findCity(this.conditions.provinceId)
      } else {
        this.base.cityId = null
        this.cityList = []
      }
    },

    // 编辑计划信息
    editFun() {
      this.getFiveLevelSource()
      localStorage.setItem('activityEditForm', JSON.stringify(this.visitObj))
      localStorage.setItem('classType', JSON.stringify(this.classType))
      this.showSaveBtn = true
      this.editDisabled = false
    },
    // 取消计划信息编辑
    cancelFun() {
      this.visitObj = JSON.parse(localStorage.getItem('activityEditForm'))
      this.classType = JSON.parse(localStorage.getItem('classType'))
      this.showSaveBtn = false
      this.editDisabled = true
    },

    // 编辑经销商信息
    editDlrFun(row) {
      this.editData = { ...row }
      this.editDialog = true
    },
    editCancel() {
      this.editDialog = false
    },


    // 处理输入的核销比例，不能超过100
    handleInput() {
      // 获取用户输入的值
      let value = this.editData.writeRate
      // 移除非数字字符
      value = value.replace(/[^\d]/g, '')
      // 最大值限制为100
      if (value > 100) {
        value = 100
      }
      // 更新数据
      this.editData.writeRate = value
    },
    disabledTime(current) {
      return current && current < moment(this.visitObj.planStartTime);
    }
  }
}
</script>
<style lang="less" scoped>
.CertificateReleaseApplicationBox {
  width: 100%;
  overflow: auto;
  padding: 0 5px;
  .elcolSpan {
    font-size: 12px;
    color: #606266;
    text-align: center;
  }
  .budgetBox {
    margin: 0 0 5px 0;
    .select-form {
      /deep/ .ant-form-item {
        display: flex;
        margin-right: 10px;
      }
    }
  }
}

.a-input__inner {
  color: #4d4d4d;
}
.fixedButton {
  // padding: 0px 5px 0px;
  margin: 0 0 5px 0;
  border-bottom: 1px solid rgb(201, 201, 201);
  .examineButton {
    margin: 5px;
  }
}
.item-line {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  // margin-left: 2%;
  background: #0a76a4;
  color: #ffffff;
  //background: #2D2E33;
  //color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.bodyBox {
  // margin: 0 34px;
}
.usereq {
  .a-row {
    margin: 5px 0 !important;
  }
  .grid-content,
  .grid-Prohibit {
    text-align: center;
    font-size: 16px;
    border-radius: 4px;
    min-height: 36px;
  }
  .grid-content .el-checkbox__label {
    font-size: 16px;
  }
  .left_content {
    height: 80%;
    padding: 0 10px 10px 10px;
    overflow-y: auto;
    border-radius: 5px;
  }
  .center_content {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  .a-select.a-input--small .a-input__inner {
    color: #616b80;
    width: 100%;
    background: #152841;
    border-color: #152841;
    border-radius: 5px;
  }
  .el-checkbox-group .el-checkbox__label {
    display: none;
  }
  .center {
    text-align: center;
  }
  .center_content_r {
    width: 90%;
    height: 200px;
    margin-top: 200px;
  }
  .rule_btn {
    width: 100%;
    height: 60px;
    background: #28548e;
    float: left;
    border: none;
  }
  .rule_btn_left,
  .rule_btn_right {
    background: #1074f6;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 3px;
  }
  .rule_btn_left img {
    transform: rotate(180deg);
  }
  .rule_btn_left:hover,
  .rule_btn_right:hover {
    background: #1e3a5f;
  }
}
.a-input.is-disabled .a-input__inner {
  color: #6a6a6a;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #6a6a6a;
}
.sourceSelect .a-input .a-select__caret.a-input__icon::before {
  content: '';
}

</style>
